var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2576_3850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70639 18.9142C9.03656 18.5155 7.7374 17.6919 6.45697 16.5978C4.87189 15.2435 2.98242 13.187 2.98242 11.081V4.63374C4.33786 4.46712 5.61206 4.11095 6.78122 3.57097C7.89923 3.05457 8.879 2.38935 9.70599 1.58643C10.533 2.38938 11.5128 3.05457 12.6309 3.57097C13.8 4.11095 15.0744 4.46715 16.4299 4.63374V11.081C16.4299 13.1955 14.5263 15.2601 12.9295 16.6197C11.6527 17.7068 10.3702 18.5195 9.70639 18.9142Z",
    fill: "#54F49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70599 2.94479C8.95789 3.55685 8.11746 4.07932 7.19153 4.50698C6.18716 4.97087 5.1131 5.30884 3.98242 5.51768V11.0809C3.98242 12.4077 5.07956 14.0792 7.07172 15.7874C8.0379 16.6159 9.01978 17.285 9.70706 17.7189C10.3795 17.2946 11.335 16.6437 12.291 15.8296C14.3152 14.1062 15.4299 12.4197 15.4299 11.0809V5.51771C14.2991 5.30884 13.2249 4.97087 12.2205 4.50698C11.2946 4.07932 10.4541 3.55685 9.70599 2.94479ZM9.70599 0.0898438C11.4611 2.25203 14.2701 3.51312 17.4299 3.69343V11.0809C17.4299 15.9458 9.70599 20.0898 9.70599 20.0898C9.70599 20.0898 1.98242 15.9458 1.98242 11.0809V3.69343C5.14194 3.51312 7.9509 2.25203 9.70599 0.0898438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2576_3850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(0.982422 0.0898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.ad7583d7d57dd7b7ad52798e29de0a25.svg";
export { ForwardRef as ReactComponent };